import React, {useEffect, useState} from "react";
import "./HomeworkPage.sass"
import {useNavigate, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../../common/anonymous/Spinner";
import Window from "../../../_containers/window/Window";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import AddIcon from "@mui/icons-material/Add";
import {setEmpty} from "../../../_actions/group/groupReducer";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import {FAILED, IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import {useSnackbar} from "notistack";
import {getGroupById, getHomeworkByGroupIdAndUserId, saveHW, updateHW} from "../../../_actions/group/groupService";
import HomeworkSetting from "../../../_components/common/HomeworkSetting";
import {taskTypes} from "../../../common/themes";
import {ORDINARY} from "../../../common/taskTypes";

const initStep = {
    theme: undefined,
    solveType: undefined,
    taskType: taskTypes[0].value,
    complexity: 1,
    speed: 1.8,
    length: 5,
    count: 10,
}
export default function HomeworkEditorPage() {
    const {id, userId} = useParams();

    const [theme, setTheme] = useState();
    const [solveType, setSolveType] = useState();
    const [taskType, setTaskType] = useState(ORDINARY);
    const [complexity, setComplexity] = useState(1);
    const [speed, setSpeed] = useState(1.8);
    const [length, setLength] = useState(5);
    const [count, setCount] = useState(10);

    const [currentStep, setCurrentStep] = useState(0)
    const [steps, setSteps] = useState([initStep]);


    const {status: groupStatus} = useSelector(state => state.groups.selected);
    const {data: hwData, status: hwStatus} = useSelector(state => state.groups.getHomework);
    const {message, status: saveHWStatus} = useSelector(state => state.groups.saveHW);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (groupStatus === IDLE) {
            dispatch(getGroupById(id))
        }
    }, [groupStatus, dispatch]);
    useEffect(() => {
        if (userId && hwStatus === IDLE) {
            const body = {
                groupId: id,
                userId: userId
            }
            dispatch(getHomeworkByGroupIdAndUserId(body))
        }
        if (hwData) {
            setSteps([...hwData.steps])
            setCurrentStep(0)

            const cur = hwData.steps[0];
            setTheme(cur.theme)
            setSolveType(cur.solveType)
            setTaskType(cur.taskType)
            setComplexity(cur.complexity)
            setSpeed(cur.speed)
            setLength(cur.length)
            setCount(cur.count)
        }
    }, [hwStatus, hwData, dispatch]);
    useEffect(() => {
        if (saveHWStatus === FAILED) {
            enqueueSnackbar(message, {variant: "error"})
        }
        if (saveHWStatus === SUCCESS) {
            enqueueSnackbar(message, {variant: "success"})
            navigate(`/home/group/${id}`);
        }
    }, [saveHWStatus, dispatch]);
    useEffect(() => {
        document.title = 'КьюАй - Настройка домашнего задания'
        return () => {
            dispatch(setEmpty())
        }
    }, []);

    if (groupStatus === LOADING || groupStatus === IDLE
        || saveHWStatus === LOADING
        || (userId && (hwStatus === IDLE || hwStatus === LOADING))) {
        return <Spinner/>
    }

    const handleChangeHWItem = (i) => {
        steps[currentStep] = {
            ...steps[currentStep],
            theme,
            solveType,
            taskType,
            complexity,
            speed,
            length,
            count
        };
        setSteps(steps);

        setCurrentStep(i)

        const cur = steps[i];
        setTheme(cur.theme)
        setSolveType(cur.solveType)
        setTaskType(cur.taskType)
        setComplexity(cur.complexity)
        setSpeed(cur.speed)
        setLength(cur.length)
        setCount(cur.count)
    }

    const handleAddItem = () => {
        const position = steps.length;
        const forSaving = {
            ...steps[currentStep],
            theme,
            solveType,
            taskType,
            complexity,
            speed,
            length,
            count
        };
        let result = [...steps, initStep];
        result[currentStep] = forSaving;

        setSteps(result);
        setCurrentStep(position);

        setTheme(initStep.theme)
        setSolveType(initStep.solveType)
        setTaskType(initStep.taskType)
        setComplexity(initStep.complexity)
        setSpeed(initStep.speed)
        setLength(initStep.length)
        setCount(initStep.count)
    }

    const handleRemoveStep = () => {
        if (steps.length > 1) {
            let s = [...steps];
            s.splice(currentStep, 1);
            setSteps(s);
            const newCurr = currentStep > 0 ? currentStep - 1 : 0;
            setCurrentStep(newCurr);

            const cur = s[newCurr];
            setTheme(cur.theme)
            setSolveType(cur.solveType)
            setTaskType(taskType)
            setComplexity(cur.complexity)
            setSpeed(cur.speed)
            setLength(cur.length)
            setCount(cur.count)
        }
    }

    const handleSaveHW = () => {
        steps[currentStep] = {
            ...steps[currentStep],
            theme,
            solveType,
            taskType,
            complexity,
            speed,
            length,
            count
        };

        if (hwData) {
            const body = {
                ...hwData,
                steps: steps
            }

            dispatch(updateHW(body))
        } else {
            const body = {
                groupId: id,
                steps: steps,
            };

            dispatch(saveHW(body))
        }
    }

    const renderStep = (item, i) => {
        return (
            <CircleButton key={`step-key-${i}`}
                          onClick={i === currentStep
                              ? () => {
                              }
                              : () => handleChangeHWItem(i)}
                          Icon={HomeOutlinedIcon}
                          backgroundColor={i === currentStep ? '#3B687A' : null}/>
        )
    }

    return (
        <Window>
            <div className="HomeworkPage-header">
                <div className="HomeworkPage-header-title">
                    Настройка сложности
                </div>
                <div className="HomeworkPage-header-button">
                    <CircleButton Icon={CloseIcon} onClick={() => navigate(`/home/group/${id}`)}/>
                </div>
            </div>
            <HomeworkSetting theme={theme}
                             setTheme={setTheme}
                             solveType={solveType}
                             setSolveType={setSolveType}
                             taskType={taskType}
                             setTaskType={setTaskType}
                             complexity={Math.log10(complexity)}
                             setComplexity={(value) => setComplexity(Math.pow(10, value))}
                             speed={speed}
                             setSpeed={setSpeed}
                             length={length}
                             setLength={setLength}
                             count={count}
                             setCount={setCount}
                             isShowCount={true}/>
            <div className="HomeworkPage-hw-list">
                <div className="HomeworkPage-hw-steps-wrapper">
                    <div className="HomeworkPage-hw-steps">
                        {steps.map(renderStep)}
                        <CircleButton Icon={AddIcon} onClick={handleAddItem}/>
                    </div>
                </div>
                <div className="HomeworkPage-hw-delete-step">
                    <ButtonComponent onClick={handleRemoveStep}>
                        Удалить шаг
                    </ButtonComponent>
                </div>
            </div>
            <div className="HomeworkPage-buttons">
                <ButtonComponent onClick={handleSaveHW}>
                    Сохранить
                </ButtonComponent>
            </div>
        </Window>
    )
}